export default "__VITE_ASSET__D8lF_OB3__"